{
  "close": "Zamknij",
  "notifications": "Powiadomienia"
}
